import { render, staticRenderFns } from "./RemoveBookingDialog.vue?vue&type=template&id=295ded38"
import script from "./RemoveBookingDialog.vue?vue&type=script&lang=js"
export * from "./RemoveBookingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports